import api from "./axios";

class ServiceSicca {
  async generate(startDate, endDate) {
    const { data } = await api.post(`/sicca`, { startDate, endDate })

    return data
  }

  async verify() {
    const { data } = await api.get(`/sicca/verify`)

    return data
  }
}

export default new ServiceSicca()